<div class="cr-channel-navbar">
  <div class="cr-segmented cr-device-toggle">
    <button
      type="button"
      class="cr-segmented-btn cr-icon-only"
      [class.active]="deviceMode === 'desktop'"
      (click)="setDeviceMode.emit('desktop')"
      title="Desktop preview"
    >
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
        <rect x="2" y="3" width="16" height="11" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
        <path d="M7 17h6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>
    </button>
    <button
      type="button"
      class="cr-segmented-btn cr-icon-only"
      [class.active]="deviceMode === 'mobile'"
      (click)="setDeviceMode.emit('mobile')"
      title="Mobile preview"
    >
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
        <rect x="5" y="2" width="10" height="16" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      </svg>
    </button>
  </div>

  <button
    type="button"
    class="cr-btn cr-lock-btn"
    *ngIf="lockInfo"
    [class.locked-other]="lockInfo.locked && !lockInfo.mine"
    [class.locked-mine]="lockInfo.locked && lockInfo.mine"
    [disabled]="lockInfo.locked && !lockInfo.mine"
    [title]="lockInfo.locked && !lockInfo.mine ? 'Locked by ' + lockInfo.label : ''"
    (click)="toggleLock.emit()"
  >
    <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
      <rect x="4" y="9" width="12" height="8" rx="1.5" stroke="currentColor" stroke-width="1.4"/>
      <path *ngIf="lockInfo.locked" d="M6.5 9V6.5a3.5 3.5 0 017 0V9" stroke="currentColor" stroke-width="1.4"/>
      <path *ngIf="!lockInfo.locked" d="M6.5 9V6.5a3.5 3.5 0 016.5-1.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </svg>
    <span *ngIf="lockInfo.locked && lockInfo.mine">Unlock</span>
    <span *ngIf="lockInfo.locked && !lockInfo.mine">Locked</span>
    <span *ngIf="!lockInfo.locked">Lock</span>
  </button>

  <span class="cr-channel-navbar-warning" *ngIf="warningMessage">{{ warningMessage }}</span>

  <div class="cr-segmented cr-view-toggle">
    <button
      type="button"
      class="cr-segmented-btn"
      [class.active]="reviewMode === 'off' && !isReadonlyMode"
      [disabled]="editDisabled && reviewMode === 'off'"
      [title]="editDisabled && reviewMode === 'off' ? 'Lock the template to edit it' : ''"
      (click)="onEdit()"
    >
      Edit
    </button>
    <button type="button" class="cr-segmented-btn" *ngIf="reviewMode === 'off'" [class.active]="isReadonlyMode" (click)="onView()">
      View
    </button>
    <button type="button" class="cr-segmented-btn" [class.active]="reviewMode === 'proof'" title="Show the version pulled in for review" (click)="setReviewMode.emit('proof')">
      Proof
    </button>
    <button type="button" class="cr-segmented-btn" *ngIf="reviewMode !== 'off'" [class.active]="reviewMode === 'annotate'" title="Click the newsletter to place a pin" (click)="setReviewMode.emit('annotate')">
      Annotate
    </button>
  </div>

  <ng-container *ngIf="reviewMode === 'off'">
    <div class="cr-lang-dropdown">
      <select
        class="cr-select cr-lang-select"
        [ngModel]="selectedLanguage"
        (ngModelChange)="languageChange.emit($event)"
        [disabled]="languageDisabled"
      >
        <option *ngFor="let lang of languages" [value]="lang">{{ lang.toUpperCase() }}</option>
      </select>
    </div>

    <button type="button" class="cr-icon-btn" (click)="refresh.emit()" title="Refresh">
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none">
        <path d="M17 10a7 7 0 10-2.3 5.2M17 5v5h-5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <div class="undo-redo-wrapper">
      <button type="button" class="cr-icon-btn undo-redo-btn" (click)="onUndo()" [disabled]="!canUndo" title="Undo (Ctrl+Z)" aria-label="Undo">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M9 7 4.5 11.5 9 16"/>
        <path d="M5 11.5h8.2c4.2 0 6.3 2.2 6.3 6"/>
      </svg>
    </button>

    <button type="button" class="cr-icon-btn undo-redo-btn" (click)="onRedo()" [disabled]="!canRedo" title="Redo (Ctrl+Y)" aria-label="Redo">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="m15 7 4.5 4.5L15 16"/>
        <path d="M19 11.5h-8.2c-4.2 0-6.3 2.2-6.3 6"/>
      </svg>
    </button>
    </div>

    <button type="button" class="cr-btn cr-btn-secondary cr-save-btn" [disabled]="saveDisabled" (click)="save.emit()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 3.5h11l3 3V20H5z"/>
        <path d="M8 3.5v6h8v-5"/>
        <rect x="8" y="13" width="8" height="7" rx="1"/>
      </svg>
      <span>{{ saveLabel }}</span>
    </button>
  </ng-container>

  <div class="cr-share-wrap" *ngIf="reviewMode !== 'off'">
    <button type="button" class="cr-btn cr-btn-secondary cr-share-btn" title="Generate view link" [disabled]="!shareUrl" (click)="openShare()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">
        <circle cx="18" cy="5" r="2.5"></circle>
        <circle cx="6" cy="12" r="2.5"></circle>
        <circle cx="18" cy="19" r="2.5"></circle>
        <path d="m8.2 10.8 7.6-4.4M8.2 13.2l7.6 4.4"></path>
      </svg>
      <span>Share</span>
    </button>
    <div class="cr-share-popover" *ngIf="shareOpen && shareUrl">
      <input type="text" class="cr-input" readonly [value]="shareUrl" aria-label="Share link" />
      <button type="button" class="cr-btn cr-btn-primary" (click)="copyShareUrl()">Copy</button>
      <button type="button" class="cr-share-close" aria-label="Close" (click)="shareOpen = false">×</button>
    </div>
  </div>
</div>
